import { render, staticRenderFns } from "./Escolas.vue?vue&type=template&id=24298584&scoped=true&"
import script from "./Escolas.vue?vue&type=script&lang=js&"
export * from "./Escolas.vue?vue&type=script&lang=js&"
import style0 from "./Escolas.vue?vue&type=style&index=0&id=24298584&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24298584",
  null
  
)

export default component.exports